export default "__VITE_ASSET__BLefHvUd__"